import { render, staticRenderFns } from "./OutrasInformacoesVersao.vue?vue&type=template&id=91858c7e&scoped=true"
import script from "./OutrasInformacoesVersao.vue?vue&type=script&lang=js"
export * from "./OutrasInformacoesVersao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91858c7e",
  null
  
)

export default component.exports